"use client";

import { c as _c } from "react/compiler-runtime";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Loader2, Moon, Sun, Monitor, Check } from "lucide-react";
export function ThemeSwitcherClient() {
  const $ = _c(44);
  const [mounted, setMounted] = useState(false);
  const {
    theme,
    setTheme
  } = useTheme();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setMounted(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!mounted) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="flex h-9 w-9 items-center justify-center"><Loader2 className="h-4 w-4 animate-spin text-muted-foreground" /></div>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] !== theme) {
    t2 = () => {
      switch (theme) {
        case "dark":
          {
            return <Moon className="h-4 w-4" />;
          }
        case "light":
          {
            return <Sun className="h-4 w-4" />;
          }
        default:
          {
            return <Monitor className="h-4 w-4" />;
          }
      }
    };
    $[3] = theme;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const ThemeIcon = t2;
  let t3;
  if ($[5] !== ThemeIcon) {
    t3 = <ThemeIcon />;
    $[5] = ThemeIcon;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="sr-only">Toggle theme</span>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <DropdownMenuTrigger asChild={true}><Button variant="outline" size="icon" className="h-9 w-9 rounded-full">{t3}{t4}</Button></DropdownMenuTrigger>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== setTheme) {
    t6 = () => setTheme("light");
    $[10] = setTheme;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Sun className="h-4 w-4" />;
    t8 = <span>Light</span>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[14] !== theme) {
    t9 = theme === "light" && <Check className="ml-auto h-4 w-4" />;
    $[14] = theme;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t9) {
    t10 = <DropdownMenuItem onClick={t6}>{t7}{t8}{t9}</DropdownMenuItem>;
    $[16] = t6;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== setTheme) {
    t11 = () => setTheme("dark");
    $[19] = setTheme;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Moon className="h-4 w-4" />;
    t13 = <span>Dark</span>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t12 = $[21];
    t13 = $[22];
  }
  let t14;
  if ($[23] !== theme) {
    t14 = theme === "dark" && <Check className="ml-auto h-4 w-4" />;
    $[23] = theme;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t11 || $[26] !== t14) {
    t15 = <DropdownMenuItem onClick={t11}>{t12}{t13}{t14}</DropdownMenuItem>;
    $[25] = t11;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== setTheme) {
    t16 = () => setTheme("system");
    $[28] = setTheme;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  let t18;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Monitor className="h-4 w-4" />;
    t18 = <span>System</span>;
    $[30] = t17;
    $[31] = t18;
  } else {
    t17 = $[30];
    t18 = $[31];
  }
  let t19;
  if ($[32] !== theme) {
    t19 = theme === "system" && <Check className="ml-auto h-4 w-4" />;
    $[32] = theme;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t16 || $[35] !== t19) {
    t20 = <DropdownMenuItem onClick={t16}>{t17}{t18}{t19}</DropdownMenuItem>;
    $[34] = t16;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t10 || $[38] !== t15 || $[39] !== t20) {
    t21 = <DropdownMenuContent align="end">{t10}{t15}{t20}</DropdownMenuContent>;
    $[37] = t10;
    $[38] = t15;
    $[39] = t20;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== t21 || $[42] !== t5) {
    t22 = <DropdownMenu>{t5}{t21}</DropdownMenu>;
    $[41] = t21;
    $[42] = t5;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  return t22;
}